import React, { useCallback } from 'react'
import { PAGE_URL_CATALOG, PAGE_URL_CART } from 'SiteURLs'

interface ITopNavLinksNotAuthProps {
  currentHash: string
  onLogin: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const TopNavLinksNotAuth: React.FC<ITopNavLinksNotAuthProps> = ({
  currentHash,
  onLogin,
}) => {
  const getNavClass = useCallback(
    (href) => {
      if (currentHash === href) return 'nav-link topmenu-link active'
      else return 'nav-link topmenu-link'
    },
    [currentHash]
  )

  return (
    <>
      <a className={getNavClass('#/' + PAGE_URL_CATALOG)} href={'#/' + PAGE_URL_CATALOG}>
        Каталог
      </a>
      <a className={getNavClass('#/' + PAGE_URL_CART)} href={'#/' + PAGE_URL_CART}>
        Корзина
      </a>{' '}
      <a className='nav-link topmenu-link' href={'#/'} onClick={onLogin}>
        Вход
      </a>
    </>
  )
}
export default TopNavLinksNotAuth
